import type { PosMappingDto } from "../../types/PosMappingDto";
import type { PosMappingEntity } from "../../types/PosMappingEntity";

export const PosMappingEntityToDto = ({ ...rest }: Readonly<PosMappingEntity>): PosMappingDto => {
    return { ...rest };
};
